import React from "react";

export const PriceStrike = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="39"
    height="19"
    viewBox="0 0 39 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M37.8002 0.799805L0.800171 17.7998"
      stroke="#0D0C1C"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);
